import {useMutation} from "@tanstack/react-query";

import {removeClientNoteMutationOptions} from "./remove-client-note.mutation-options";

export function useRemoveClientNote(clientId: string) {
  return useMutation(removeClientNoteMutationOptions(clientId));
}
